import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
export default function Footer() {

  const [loanData,setLoanData] = React.useState([])
  const [investmentData,setInvestmentData] = React.useState([])
  const fetchLoanData = () => {
    axios.get("https://api.dremerz.net/api/bankshoppyloan")
    .then((res)=>{
      console.log(res.data)
      setLoanData(res.data)
    })
    .catch((err)=>{
      console.log(err)
    })

    axios.get("https://api.dremerz.net/api/bankshoppyinvestment")
    .then((res)=>{
      console.log(res.data)
      setInvestmentData(res.data)
    })
    .catch((err)=>{
      console.log(err)
    })
  }

  React.useEffect(()=>{
    fetchLoanData()
  }
  ,[])


  return (
    <footer
  className="footer footer-2 pt-lg-130 pt-110 pb-100 pb-lg-125"
  style={{ backgroundImage: "url(img/footer/footer-bg-2.png)" }}
>
  <div className="footer-top">
    <div className="container">
      <div className="row">
        <div className="col-lg-3  col-sm-6 text-center text-sm-start">
          <div className="footer-widget mb-30 wow fadeInLeft">
            <h4 className="mb-20">About Us</h4>
            <div className="footer-text mb-20">
              <p>
               {/* // about bankshoppy  */}
               We are a team of passionate people whose goal is to improve everyone's life through disruptive products. We build great products to solve your problems.

              </p>
            </div>
            <div className="truspilot mt-40">
              <img src="img/footer/Trustpilot.png" alt="Trustpilot" />
            </div>
          </div>
        </div>
        <div className="col-lg-3  col-sm-6 text-center text-sm-start offset-lg-1">
          <div
            className="footer-widget mb-30 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="f-widget-title">
              <h5>Loan</h5>
            </div>
            <div className="footer-link">
              <ul>
                {
                  loanData.map((data,index)=>{
                    return(
                    <li key={index}>
                    <Link to={"/loan"} state={data}  >{data.loanName}</Link>
                  </li>
                  )})
                }
             
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-3  col-sm-6 text-center text-sm-start">
          <div
            className="footer-widget mb-30 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="f-widget-title">
              <h5>Invesments</h5>
            </div>
            <div className="footer-link">
              <ul>
              {
                  investmentData.map((data,index)=>{
                    return(
                    <li key={index}>
                    <Link to={"/investments"} state={data}  >{data.loanName}</Link>
                  </li>
                  )})
                }
             
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-2  col-sm-6 text-center text-sm-start">
          <div
            className="footer-widget mb-30 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="f-widget-title">
              <h5>Quick Links</h5>
            </div>
            <div className="footer-link">
              <ul>
               
                <li>
                  <Link to='/contact'>Contact Us</Link>
                </li>
                {/* <li>
                  <a href="#">Security Center</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="copyright pt-45">
    <div className="container">
      <div className="row ">
        <div className="col-xl-8 offset-xl-4">
          <div className="row">
            <div className="copyright-text text-md-start text-center">
              <a href='https://dremerz.net'>
                Designes & Developed by Dremerz Consultancy & Services
                
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

  )
}
